var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-entry-detail" },
    [
      _c("title-block", {
        attrs: { title: _vm.entryTitle, classes: "is-3 is-detail" }
      }),
      _c("div", { staticClass: "box" }, [
        _c("div", { staticClass: "c-entry-detail__meta" }, [
          _c("table", { staticClass: "table is-fullwidth" }, [
            _vm._m(0),
            _c("tbody", [
              _c("tr", [
                _c("td", { attrs: { nowrap: "" } }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v(_vm._s(_vm.setDate(this.entryDate)))
                  ])
                ]),
                _c("td", [
                  _vm.categories.length
                    ? _c(
                        "div",
                        { staticClass: "tags" },
                        _vm._l(_vm.categories, function(c) {
                          return _c(
                            "div",
                            { staticClass: "tag is-secondary" },
                            [_vm._v(_vm._s(c.label))]
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ])
              ])
            ])
          ])
        ]),
        _c(
          "div",
          { ref: "content", staticClass: "content" },
          [_vm._t("default")],
          2
        )
      ]),
      _c("div", { staticClass: "buttons" }, [
        _c(
          "a",
          {
            staticClass: "button",
            on: {
              click: function($event) {
                return _vm.backPage()
              }
            }
          },
          [_vm._m(1), _c("span", [_vm._v("前のページに戻る")])]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [_c("col", { attrs: { width: "1%" } }), _c("col")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("i", { staticClass: "material-icons has-text-primary" }, [
        _vm._v("chevron_left")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }